<template>
  <div class="content-part">
    <div class="list-part">
      <div class="list-title-text">已存在关系</div>
      <div class="info-part" v-for="item in clients"
           :key="item.id"
           @click="overCilentsInfo(item.relationId)"
      >
        <span style="font-size: 1rem;letter-spacing:1px;margin-left:36px;color:black">{{ item.relationName }}</span>
        <div class="info-msg">
          <span>{{ gainMatchup(item.type) }}</span>
          <i class="iconfont icon-shanchu" style="margin-left:49px;font-size:1.2rem;color: red"
             @click="removeCilentsRelation(item.id,item.groupKey)"
          ></i>
        </div>
      </div>
    </div>
    <div class="relationship">
      <div class="list-title-text">添加关系</div>
      <div class="add-part">
        <div class="add-part-title">
          添加关系
        </div>
        <div class="add-part-client-relation">
          <span style="margin-left:36px">客户姓名：</span>
          <el-autocomplete
            style="width:276px;height:36px"
            popper-class="my-autocomplete"
            v-model="client"
            :fetch-suggestions="querySearch"
            placeholder="请输入姓名和电话"
            ref="elAutocomplete"
            @select="handleSelect"
            :trigger-on-focus="true"
          >
            <i
              class="el-icon-search"
              style="font-size: 20px;margin-top: 11px"
              slot="suffix"
              @click="showSearchColumn"
            >
            </i>
            <template slot-scope="{ item }">
              <div class="search-title" v-if="item.id === subOneId">
                <span>姓名</span>
                <span style="margin-right: 2rem">电话</span>
              </div>
              <div class="search-list-content">
                <div class="name">{{ item.name }}</div>
                <span class="addr">{{ item.telNumber }}</span>
              </div>
            </template>
          </el-autocomplete>
        </div>
        <div class="add-part-client-relation" style="margin-top: 21px">
          <span style="margin-left:36px">选择关系：</span>
          <el-select
            style="width:276px;height:36px"
            v-model="type" placeholder="请选择">
            <el-option
              v-for="item in relations"
              :key="item.id"
              :label="item.text"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="confirm-btn"
             @click="ensure"
        >
          确定
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "../../axios/axios";
import ipAddress from "../../axios/ipAddress";
import {Message} from "element-ui";

export default {
  name: "coustRelat",
  data() {
    return {
      id: '',
      clients: [],
      relations: [],
      type: '',  //客户关系
      client: '',
      clientId: 0,
      subOneId: 0,
    }
  },
  created() {
    this.id = this.$route.params.id
    //获取关系列表
    this.gainRelations()
    //查看客户客户关系
    this.examine_client_relation()
  },
  methods: {
    //查看客户关系
    examine_client_relation() {
      let params = new URLSearchParams()
      params.set("customerId", this.id)
      axios.post(`${ipAddress.qi}/admin/a1/customer-relation/listByCid`, params).then(
        value => {
          const content = value.content
          if (content) {
            this.clients = content
          }
        }
      )
    },
    //获取关系列表
    gainRelations() {
      axios.post(`${ipAddress.qi}/admin/a1/commons/getRelationType`).then(
        value => {
          const content = value.content
          if (content) {
            this.relations = content
          }
        }
      )
    },

    //获取对应关系
    gainMatchup(type) {
      const [result] = this.relations.filter(data => data.id === type)
      return result.text
    },


    //删除对应用户关系
    removeCilentsRelation(id, key) {
      let params = new URLSearchParams()
      params.set("groupKey", key)
      axios.post(`${ipAddress.qi}/admin/a1/customer-relation/delInKey`, params).then(
        value => {
          const success = value.success;
          const msg = value.message;
          if (success) {
            Message.success("信息删除成功！")
            const i = this.clients.findIndex(item => item.id === id)
            this.clients.splice(i, 1) //删除对应的列表数据
          } else {
            Message.warning(msg)
          }
        }
      )
    },


    //返回输入建议的方法，仅当你的输入建议数据 resolve 时，通过调用 callback(data:[]) 来返回它
    querySearch(text, callback) {
      if (text) {
        let params = {
          customerId: this.id,
          key: text,
          type: 0
        }
        axios.post(`${ipAddress.qi}/admin/a1/customer/queryLimited`, params, true).then(
          value => {
            let content = value.content
            if (!content || content.length < 1) {
              content = [{id: -1, name: "暂无匹配数据"}]
            } else {
              this.subOneId = content[0].id //记录第一个姓名的id用于判断
            }
            // 调用 callback 返回建议列表的数据
            callback(content)
          }
        )
      }
    },

    //仅在输入框失去焦点或用户按下回车时触发
    handleSelect(event) {
      this.client = event.name
      this.clientId = event.id
    },


    showSearchColumn() {
      this.$refs.elAutocomplete.handleFocus()
    },


    //点击确定上传关系
    ensure() {
      if (!this.client) {
        Message.warning("请输入客户姓名！")
        return
      }
      if (!this.type) {
        Message.warning("请选择和客户的关系!")
        return;
      }
      let params = {
        customerId: this.id,
        relationId: this.clientId,
        relationName: this.client,
        type: this.type,
      }
      axios.post(`${ipAddress.qi}/admin/a1/customer-relation/save`, params, true).then(
        value => {
          const content = value.content
          const success = value.success
          const msg = value.message
          if (success) {
            Message.success("添加成功！")
            this.clients = [...this.clients, content]
            //请空开始选择的信息
            this.clientId = 0;
            this.client = '';
            this.type = ''
          } else {
            Message.warning(msg)
          }
        }
      )
    },

    //点击查看客户关系详情
    overCilentsInfo(id) {
      this.$router.replace(`/index/customers/basicinfo/${id}`)
      // this.$router.replace({path: '/index/customers', query: {id: id}})
    }
  },
  watch:{
    $route:{
      handler(from,to){
        const fromId = from.params.id
        const  toId = to.params.id
        console.log(fromId)
        console.log(toId)
        if(!(fromId == toId)){
          this.id = this.$route.params.id
          //获取关系列表
          this.gainRelations()
          //查看客户客户关系
          this.examine_client_relation()
        }
      }
    }
  }



}
</script>

<style scoped>
.content-part {
  width: auto;
  height: auto;
  display: flex;
  margin: 0;
  padding: 0;
}

.list-part {
  width: auto;
  height: auto;
  margin-left: 7rem;
}

.list-title-text {
  font-size: 1rem;
  letter-spacing: 2px;
}

.info-part {
  width: 444px;
  height: 50px;
  display: flex;
  justify-content: space-between;
  margin-top: 12px;
  box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.16);
  align-items: center;
}

.info-msg {
  width: auto;
  height: 100%;
  display: flex;
  margin-right: 36px;
  align-items: center;
  font-size: 1rem;
  color: black;
  letter-spacing: 1px
}

.relationship {
  width: auto;
  height: auto;
  margin-left: 73px;

}

.add-part {
  width: 444px;
  height: auto;
  box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.16);
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-top: 12px;
}

.add-part-title {
  width: 100%;
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.95rem;
  letter-spacing: 2px;
  margin-top: 12px;
}

.add-part-client-relation {
  width: 100%;
  height: auto;
  display: flex;
  font-size: 0.95rem;
  letter-spacing: 1px;
  color: black;
  align-items: center;
}

.confirm-btn {
  width: auto;
  height: auto;
  margin-top: 31px;
  margin-bottom: 16px;
  padding: 0.5rem 2rem;
  color: white;
  font-size: 1.1rem;
  background-color: #3495EF;
  border-radius: 5px;
  letter-spacing: 2px;
  margin-right: 50px;
}

.search-title {
  width: 100%;
  height: 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 1rem;
  color: black;
  letter-spacing: 1px;
}

.search-list-content {
  width: 100%;
  height: auto;
  padding: 0.1rem 0;
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  letter-spacing: 1px;
  color: #717171;
}
</style>



// WEBPACK FOOTER //
// src/components/Customer/coustRelat.vue